var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogCreateNumberBase',{attrs:{"is-open":_vm.isOpen,"bases":[_vm.baseId],"default-fields":_vm.defaultFields},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }